<template>
  <div class="text-with-instagram">
    <div class="row">
      <div class="col big">
        <div class="text" v-html="content.text"></div>
      </div>
      <div class="col">
        <div class="embed-text-with-instagram" v-if="show">
            <div class="instagram-wrapper-iframe" v-html="html"></div>   
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "text_with_instagram",
  props: {
    content: Object
  },
  data: () => ({
    show: false,
    url: '',
    html: ''
  }),
  // methods: {
  //   get_extension( s ) {
  //     return s.split(/[#?]/)[0].split('.').pop().trim();
  //   }
  // },
  created() {
    this.url = this.content.instagram;
    if (this.url) {
      // add embed to the end
      var lastChar = this.url.substr(-1); 
      if (lastChar != '/') {
        this.url = this.url.concat('/embed');
      }else{
        this.url = this.url.concat('embed');
      }
      // console.log(this.url);
      //prepare html
      this.html = '<iframe src="' + this.url + '" allowtransparency="true" scrolling="no" allowfullscreen="false"></iframe>';
      this.show=true;
    }
   
    
  } 
  
};
</script>

<style lang="scss">
.text-with-instagram {
  background: $white;
  color: $black;
  padding-top: 100px;
  .row {
    display: flex;
    align-items: center;
    .col {
      flex: 0.4;
      &.big {
        flex: 0.6;
      }
      .text {
        padding: 50px;
        strong {
          color: $black !important;
        }
      }
      .embed-text-with-instagram {
        position: relative;
        .instagram-wrapper-iframe {
          position: relative;          
          z-index: 2;
          background-color: red;
          box-shadow:0 0 1px 0 rgba(0,0,0,0.5);
          width: calc((100vw - 435px) * 0.35);
          height: calc(((100vw - 435px) * 0.35) + 206px);
          overflow: hidden;
          iframe{
            background:#FFF;
            padding:0; 
            width: 100%;
            height:100%; 
          }
        }
      }
    }
  }
}
@media (max-width: $desktop) {
  .text-with-instagram {
    padding: 50px 0;
    .row {
      .col {
        .embed-text-with-instagram {
          .instagram-wrapper-iframe {
            width: 35vw;
            height: calc(35vw + 206px);
          }
        }
      }
    }
  }
}
@media (max-width: $tablet) {
  .text-with-instagram {
    padding: 50px 0;
    .row {
      .col {
        flex: 0.5;
        &.big {
          flex: 0.5;
        }
        .embed-text-with-instagram {
          .instagram-wrapper-iframe {
            width: 45vw;
            height: calc(45vw + 206px);
          }
        }
      }
    }
  }
}
@media (max-width: $mobile) {
  .text-with-instagram {
    padding: 50px 0 25px 0;
    .row {
      flex-direction: column;
      max-width: 90%;
      margin: 0 auto;
      .col {
        width: 100%;
        flex: 1;
        &.big {
          flex: 1;
        }
        .text {
          position: relative;
          padding: 0;
          margin-bottom: 25px;
          z-index: 1;
        }
        .embed-text-with-instagram {
          .instagram-wrapper-iframe {
            width: 90vw;
            height: calc(90vw + 206px);
          }
        }
      }
    }
  }
}
// @media (max-width: $small-mobile) {
//   .text-with-instagram {
//     .row {
//       .col {
//         .embed-text-with-instagram {
//           .instagram-wrapper-iframe {
//             width: 90vw;
//             height: calc(90vw + 206px);
//           }
//         }
//       }
//     }
//   }
// }



// .embed-instagram {
//   position: relative;
//   &:before {
//     content: "";
//     position: absolute;
//     top: 0;
//     left: 10%;
//     width: calc(90% - 500px);
//     height: 100%;
//     background: rgba(184, 184, 184, 0.2);
//   }
//   .instagram-wrapper-iframe {
//     position: relative;
//     margin-left: calc(100% - 500px - 100px);
//     z-index: 2;
//     background-color: white;
//     box-shadow:0 0 1px 0 rgba(0,0,0,0.5);
//     width: 500px;
//     height: 832px;
//     overflow: hidden;
//     iframe{
//       background:#FFF;
//       padding:0; 
//       width: 100%;
//       height:100%; 
//     }
//   }
// }
// @media (max-width: $tablet) {
//   .embed-instagram {
//     &:before {
//       display: none;
//     }
//     .instagram-wrapper-iframe {
//       margin-left: 0;
//       width: 400px;
//       height: 707px;
//     }
//   }
// }
// @media (max-width: $mobile) {
//   .embed-instagram {   
//     .instagram-wrapper-iframe {
//       text-align: center;
//       width: 90vw;
//       height: 170vw;
//       margin-left: 5%;
//       padding-bottom: 20px;
//       padding-top: 20px;
//       z-index: 5;
//     }
//   }
// }

</style>